import { COLOR_VARIANTS, CurrencySymbol, Typography, TYPOGRAPHY_VARIANT } from '@tajawal/ct-web-design-system';
import React from 'react';

import { FormatSARToRiyalSymbol } from '@/app-common/components/FormatSARToRiyalSymbol/FormatSARToRiyalSymbol';
import _map from 'lodash/map';

type BaggageInfoTitleProps = {
  baggageText: string;
  isIncluded?: boolean;
  isUnderSeatBaggage?: boolean;
  price?: number;
  currency?: string;
  displayCurrency?: boolean;
};

export function BaggageInfoTitle({
  baggageText,
  isIncluded,
  isUnderSeatBaggage,
  price,
  currency,
  displayCurrency,
}: BaggageInfoTitleProps): JSX.Element {
  function formatBaggageText() {
    if (!isUnderSeatBaggage || config?.language === 'en') {
      const splitBaggage = baggageText.split(',');

      return (
        <div
          style={{
            display: 'flex',
            gap: '2px',
          }}
        >
          {_map(splitBaggage, (part, index) => {
            const isLastPart = splitBaggage.length === index + 1;
            return (
              <React.Fragment key={part}>
                <FormatSARToRiyalSymbol
                  color={!isIncluded ? COLOR_VARIANTS.GREYCHATEAU : COLOR_VARIANTS.MINESHAFT}
                  variant={TYPOGRAPHY_VARIANT.BODY2}
                  disclaimer={part}
                />
                {isLastPart ? '' : ','}
              </React.Fragment>
            );
          })}
        </div>
      );
    }

    const splitBaggageText = baggageText.split('(');
    return (
      <>
        <FormatSARToRiyalSymbol disclaimer={splitBaggageText?.[0]} />

        <Typography
          variant={TYPOGRAPHY_VARIANT.BODY2}
          component="span"
          sx={{
            direction: 'rtl',
            unicodeBidi: 'bidi-override',
          }}
          color={!isIncluded ? COLOR_VARIANTS.GREYCHATEAU : COLOR_VARIANTS.MINESHAFT}
        >
          <FormatSARToRiyalSymbol
            disclaimer={`(${splitBaggageText?.[1]}`}
            color={!isIncluded ? COLOR_VARIANTS.GREYCHATEAU : COLOR_VARIANTS.MINESHAFT}
            variant={TYPOGRAPHY_VARIANT.BODY2}
          />
        </Typography>
      </>
    );
  }

  return (
    <Typography
      component="p"
      variant={TYPOGRAPHY_VARIANT.BODY2}
      color={!isIncluded ? COLOR_VARIANTS.GREYCHATEAU : COLOR_VARIANTS.MINESHAFT}
      sx={{
        display: 'flex',
      }}
    >
      {formatBaggageText()}
      {displayCurrency && +price !== 0 && (
        <CurrencySymbol
          variant={TYPOGRAPHY_VARIANT.BODY2}
          currency={currency}
          color={!isIncluded ? COLOR_VARIANTS.GREYCHATEAU : COLOR_VARIANTS.MINESHAFT}
        >
          <span style={{ paddingInline: '2px' }}>{`(${price})`}</span> here
        </CurrencySymbol>
      )}
    </Typography>
  );
}
